// The new admin area. Everything under /admin/* lives here; /admin itself is the sign-in page.
import { Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom'
import { connect } from 'react-redux'

import { ROLES } from '../../utils/constants'
import AdminLayout from './AdminLayout'
import { FeedbackProvider } from './ui'
import Today from './pages/Today'
import People from './pages/People'
import Person from './pages/Person'
import SecondAccounts from './pages/SecondAccounts'
import Groups from './pages/Groups'
import Group from './pages/Group'
import Recipes from './pages/Recipes'
import Recipe from './pages/Recipe'
import RecipeEdit from './pages/RecipeEdit'
import CookbookOrders from './pages/CookbookOrders'
import CookbookJourneys from './pages/CookbookJourneys'
import CookbookJourney from './pages/CookbookJourney'
import SiteContent from './pages/SiteContent'

import './admin.css'

export { default as AdminSignIn } from './AdminSignIn'

const AdminArea = ({ userRole }) => {
  if (userRole !== ROLES.ROLE_ADMIN_USER) return <Navigate to="/admin" replace />

  return (
    <div className="adm">
      <FeedbackProvider>
        <AdminLayout>
          <Routes>
            <Route path="today" element={<Today />} />
            <Route path="people" element={<People />} />
            <Route path="people/:id" element={<Person />} />
            <Route path="second-accounts" element={<SecondAccounts />} />
            <Route path="groups" element={<Groups />} />
            <Route path="groups/:id" element={<Group />} />
            <Route path="recipes" element={<Recipes />} />
            <Route path="recipes/:id" element={<Recipe />} />
            <Route path="recipes/:id/edit" element={<RecipeEdit />} />
            <Route path="cookbook-orders" element={<CookbookOrders />} />
            <Route path="cookbook-journeys" element={<CookbookJourneys />} />
            <Route path="cookbook-journeys/:id" element={<CookbookJourney />} />
            <Route path="site" element={<SiteContent />} />
            <Route path="*" element={<Navigate to="/admin/today" replace />} />
          </Routes>
        </AdminLayout>
      </FeedbackProvider>
    </div>
  )
}

export default connect(({ user }) => ({ userRole: user.userRole }))(AdminArea)

// Old admin addresses (/users, /user/:id, ...) send admins to the matching new page.
// `param` is the old route's id parameter; non-numeric ids fall back to the list.
export const redirectOldAdmin = (to, param) => {
  const OldAdminRedirect = () => {
    const params = useParams()
    const { search } = useLocation()
    if (!param) return <Navigate to={to} replace />
    const id = params[param]
    return <Navigate to={/^\d+$/.test(id || '') ? `${to}/${id}${search}` : to} replace />
  }
  return OldAdminRedirect
}
